<template>
  <div class="p-5 text-center">
    <span class="spinner-border spinner-border-sm" role="status">
      <span class="visually-hidden">
        {{ i18n('Redirecting...') }}
      </span>
    </span>
  </div>
</template>

<script>
import api from "@/api.js";
import { firstAccessiblePage } from "@/routeAcl.js";

export default {
  components: {},
  data() {
    return {};
  },
  created() {
    this.$root.setPageTitle('');

    // Get the user object
    api.auth().then((user) => {
      if (!user || !user.id) {
        api.login(this.$route.query, {
          name: this.$route.name,
          params: this.$route.params,
        }).then((route) => {
          this.$router.push(route);
        });
        return;
      }

      // Save the user data in the root component
      this.$root.loggedUser = user;

      // Get the first accessible page
      const page = firstAccessiblePage(this.$root.loggedUser, this.$root.features);

      // Redirect to the first accessible page
      if (page) {
        this.$router.push({ name: page });
      } else {
        localStorage.clear();
        this.$router.push({ name: 'LoginError' });
      }
    });
  },
};
</script>